import { ChangeEventHandler, createContext } from 'react'
import type { VehicleSelectItemShape } from './VehicleSelectItemShape'

interface FormContextShape {
  baseUrl: string
  contractId: string
  vehicleId: string
  shouldShare: boolean
  handleContractChange?: ChangeEventHandler<HTMLSelectElement>
  handleVehicleChange?: ChangeEventHandler<HTMLSelectElement>
  handleShareChange?: ChangeEventHandler<HTMLInputElement>
  selectOptions: VehicleSelectItemShape[]
}

export const FormContext = createContext<FormContextShape>(
  { baseUrl: '', contractId: '', vehicleId: '', shouldShare: false, selectOptions: [] }
)

export type { FormContextShape }
